import { ClientsTable } from 'features/new-clients/components/clients-table/clients-table';
import { ClientsTopBar } from 'features/new-clients/components/top-bar/clients-top-bar';
import { useGetClientsList } from 'features/new-clients/use-cases/get-clients';
import {
  UserFilterFormValues,
  UserFilterFormValuesPaginated,
} from 'features/users/components/users-filter-form/types';
import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';
const getInitialFilterValues: UserFilterFormValues = {
  full_user_name: undefined,
  phone_number: undefined,
  email: undefined,
  role: undefined,
  company_id: undefined,
};
export const ClientsListView = () => {
  const { params, updateParams } =
    usePaginationParams<UserFilterFormValuesPaginated>({
      PageIndex: 1,
      RecordPerPage: 10,
      order_by: 'name',
      ...getInitialFilterValues,
    });

  const { data, isFetching } = useGetClientsList(params, { retry: false });

  return (
    <>
      <ClientsTopBar />
      <ClientsTable
        isFetching={isFetching}
        dataList={data?.rc}
        tableParams={params}
        updateParams={updateParams}
      />
      <Outlet />
    </>
  );
};
